import React from "react";
import Box from "@mui/material/Box";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {useNavigate, useParams} from "react-router-dom";
import CustomTabPanel from "src/components/CustomTabPanel";
import {RestaurantMenu, Coffee, Campaign} from '@mui/icons-material';
import MenuYonetimi from "../yonetim/MenuYonetimi";
import KahveYonetimi from "../yonetim/KahveYonetimi";
import KampanyaYonetimi from "../yonetim/KampanyaYonetimi";

const tabMap: { [key: string]: number } = {
    "urunler": 0,
    "kahveler": 1,
    "kampanyalar": 2
};

const indexMap: { [key: number]: string } = {
    0: "urunler",
    1: "kahveler",
    2: "kampanyalar"
};

const MenuYonetimiLayout = () => {
    const {tab} = useParams();
    const navigate = useNavigate();
    const value = tab ? tabMap[tab] ?? 0 : 0;

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        navigate(`/Logbook/menu-yonetimi/${indexMap[newValue]}`);
    };

    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper', position: 'sticky', top: 0, zIndex: 10 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        px: { xs: 1, md: 3 },
                        '& .MuiTab-root': { 
                            fontWeight: 700, 
                            minHeight: 64, 
                            textTransform: 'none', 
                            fontSize: '0.95rem',
                            color: 'text.secondary'
                        },
                        '& .Mui-selected': { color: 'primary.main' },
                        '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' }
                    }}
                >
                    <Tab icon={<RestaurantMenu sx={{ fontSize: 20 }} />} iconPosition="start" label="Ürünler" id={`menu-tab-${0}`}/>
                    <Tab icon={<Coffee sx={{ fontSize: 20 }} />} iconPosition="start" label="Kahve Çekirdekleri" id={`menu-tab-${1}`}/>
                    <Tab icon={<Campaign sx={{ fontSize: 20 }} />} iconPosition="start" label="Kampanyalar" id={`menu-tab-${2}`}/>
                </Tabs>
            </Box>
            
            <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
                <CustomTabPanel value={value} index={0} sx={{ p: 0 }}>
                    <MenuYonetimi/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1} sx={{ p: 0 }}>
                    <KahveYonetimi/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2} sx={{ p: 0 }}>
                    <KampanyaYonetimi/>
                </CustomTabPanel>
            </Box>
        </Box>
    );
}

export default MenuYonetimiLayout;
